import { memo } from "react";

function Polygon({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
      <path d="M18.43,15.86a2.58,2.58,0,0,0-.4,0l-1.41-2.36a2.54,2.54,0,0,0,0-3.08L18,8.1a2.57,2.57,0,1,0-2-3.49H8A2.57,2.57,0,1,0,4.61,8v8.1A2.57,2.57,0,1,0,8,19.39h8.1a2.57,2.57,0,1,0,2.38-3.53Zm-11.89.19V8A2.57,2.57,0,0,0,8,6.54h8.1a2.72,2.72,0,0,0,.33.57L15,9.47a2.57,2.57,0,1,0,0,5.06l1.41,2.36a2.72,2.72,0,0,0-.33.57H8A2.57,2.57,0,0,0,6.54,16.05Zm8-4.69a.64.64,0,0,1,0,1.28.64.64,0,0,1,0-1.28Zm3.86-6.43a.64.64,0,0,1,.64.64.64.64,0,1,1-.64-.64Zm-12.86,0a.64.64,0,1,1-.64.64A.64.64,0,0,1,5.57,4.93Zm0,14.14a.64.64,0,0,1-.64-.64.64.64,0,1,1,.64.64Zm12.86,0a.64.64,0,1,1,.64-.64A.64.64,0,0,1,18.43,19.07Z" />
    </svg>
  );
}
export default memo(Polygon);
